import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatRippleModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { LogoComponent } from '@suvo/frontend-framework/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/shared/logo/logo.component';
import { AngularMaterialModule } from '@suvo/frontend-framework/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/shared/modules/angular-material/angular-material.module';
import { VisualizationsModule } from '@suvo/frontend-framework/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/shared/visualisations/visualizations.module';
import { CommonComponentsModule } from '@suvo/frontend-framework/SUVO-CORE-CLIENT-LIB/projects/suvo-core-client-lib/src/lib/features/common-components/common-components.module';
import { SuvoUsersClientLibModule } from '@suvo/frontend-framework/SUVO-USERS-CLIENT-LIB/projects/suvo-users-client-lib/src/lib/suvo-users-client-lib.module';
import { environment } from '../../environments/environment';
import { SuvoHelpTextComponent } from './components/suvo-help-text';

@NgModule({
  declarations: [LogoComponent],
  exports: [
    RouterModule,
    CommonModule,
    ReactiveFormsModule,
    CommonComponentsModule,
    FormsModule,
    ReactiveFormsModule,
    MatRippleModule,
    AngularMaterialModule,
    FormsModule,
    SuvoUsersClientLibModule,
    LogoComponent,
    SuvoHelpTextComponent,
  ],
  imports: [
    MatDialogModule,
    MatTooltipModule,
    MatRippleModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    CommonModule,
    CommonComponentsModule,
    AngularMaterialModule,
    ReactiveFormsModule,
    SuvoUsersClientLibModule.forRoot(environment),
    VisualizationsModule,
    SuvoHelpTextComponent,
  ],
})
export class SharedModule {}
